module.exports = new __parcel__URL__("stardust_pack_reward.2b815b0c.png").toString();